import { render, staticRenderFns } from "./PageBgCover.vue?vue&type=template&id=33033fe8&scoped=true"
import script from "./PageBgCover.vue?vue&type=script&lang=js"
export * from "./PageBgCover.vue?vue&type=script&lang=js"
import style0 from "./PageBgCover.vue?vue&type=style&index=0&id=33033fe8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33033fe8",
  null
  
)

export default component.exports